import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { UntypedFormBuilder } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { ConsultarTramiteExternoAction } from '@smdapp/flux/visualizador/visualizador-store';
import { DocumentoTramite } from '@smdapp/shared/models/documento-tramite';
import { TipoSituacaoTramiteEnum } from '@smdapp/shared/enums/tipo-situacao-tramite-enum';
import { CookieService } from 'ngx-cookie-service';
import { ReCaptchaComponent } from 'angular2-recaptcha';
import { Services, AcessoExterno } from '../../shared';
import { AcessoExternoFormGroup } from './acesso-externo.formgroup';
import { ErroApp } from '../../shared/models/erro-app.model';
import { BnLoadingService } from '@bndes/bndes-angular-utils';
import { CodigoErroConstante } from '../../shared/constants/codigo-erro.constant';
import { RegistrarTipoAutenticacaoAction } from '../../flux/autenticacao/autenticacao-store';
import { TipoAutenticacaoEnum } from '../../shared/enums/tipo-autenticacao.enum';


@Component({
    selector: 'app-acesso-externo',
    templateUrl: './acesso-externo.component.html'
})

export class AcessoExternoComponent implements OnInit {
    private acessoExterno: AcessoExterno;
    contarErro: number = 0;
    returnUrlParam: string;
    formulario: AcessoExternoFormGroup;
    loginCaptchaResposta: string;
    loginCaptchaChaveCliente: string;
    documentoTramite: DocumentoTramite;
    lock: any;

    @ViewChild(ReCaptchaComponent) myRecaptcha: ReCaptchaComponent;
    httpClient: any;

    constructor(private activeRoute: ActivatedRoute,
        private router: Router,
        private loadingService: BnLoadingService,
        protected svc: Services,
        protected fb: UntypedFormBuilder,
        protected cookieService: CookieService)
    {
        this.formulario = new AcessoExternoFormGroup(this.fb);
        this.acessoExterno = new AcessoExterno();
        this.loginCaptchaChaveCliente = '6LdRbZ0bAAAAAMfOEYbVh76kHqE8cMTX-1ty52Ym';
        this.returnUrlParam = 'returnUrl='+location.origin + location.pathname + '#/' + this.activeRoute.snapshot.routeConfig.path;
        this.svc.logger.debug('[Inicializando] url de retorno: ', this.returnUrlParam);
    }

    showRecaptcha() {
        if (this.contarErro >= 5 && this.contarErro <= 10) {
            this.formulario.formGroup.get('myRecaptcha').enable();
            return true;
        }
        this.formulario.formGroup.get('myRecaptcha').disable();
        return false;
    }

    onScriptLoad() {
    }

    onScriptError() {
    }

    ngOnInit() {
        const parametros: Params = this.activeRoute.snapshot.queryParams;
        this.cookiesConsent();
        this.acessoExterno.respostaRecaptcha = this.loginCaptchaResposta;
        let tokenAcessoExterno = this.svc.sessionStorageService.getTokenAcessoExterno();
        if(tokenAcessoExterno != null && parametros.code != null)
        {
            this.formulario.formGroup.disable();
            this.realizarAcessoExternoGovBr(parametros);
        } else
        {
            this.getQueryParamsTokenAcessoExterno(parametros);
        }
    }

    private getQueryParamsTokenAcessoExterno(parametros) {
        if (parametros.token)
        {
            this.acessoExterno.token = parametros.token;
            this.svc.sessionStorageService.setTokenAcessoExterno(this.acessoExterno.token);
            return;
        }
        if (this.svc.sessionStorageService.getTokenAcessoExterno() != null)
        {
            this.acessoExterno.token = this.svc.sessionStorageService.getTokenAcessoExterno();
            return;
        }
        this.alertarErro('Erro', 'Não foi possível realizar o acesso.', '');
        this.contarErro++;
    }

    realizarAcessoExterno() {
        this.acessoExterno.codigoAcesso = this.formulario.formGroup.controls[this.formulario.campos.codigoAcesso.name].value;
        this.acessoExterno.cpf = this.formulario.formGroup.controls[this.formulario.campos.cpf.name].value;
        this.acessoExterno.email = this.formulario.formGroup.controls[this.formulario.campos.email.name].value.toLowerCase();
        this.acessoExterno.respostaRecaptcha = this.loginCaptchaResposta;
        this.acessoExterno.erros = this.contarErro;

        this.cookiesConsent();

        this.svc.acessoExternoService.realizarAcessosExterno(this.acessoExterno).then((acessoExterno) => {
            this.generateCookiesUri(acessoExterno.chaveAcesso);
            new RegistrarTipoAutenticacaoAction(TipoAutenticacaoEnum.CodigoAcesso).dispatch().then((state) => {
              this.consultarTramiteExterno(acessoExterno);
            });
            return;
        })
        .catch((error: any) =>
        {
          this.alertarErro('Erro', 'Não foi possível realizar o acesso.', error);
          if (!(error instanceof HttpErrorResponse))
          {
            this.contarErro++;
          }
        });

    }

    realizarAcessoExternoGovBr(parametros: Params) {
        this.loadingService.bloqueiaTela();
        this.acessoExterno.token = this.svc.sessionStorageService.getTokenAcessoExterno();
        this.acessoExterno.codeGovBr = parametros.code;
        this.acessoExterno.erros = this.contarErro;

        this.svc.acessoExternoService.realizarAcessosExternoGovBr(this.acessoExterno).then(acessoExterno => {
            this.svc.logger.info('[realizarAcessoExternoGovBr] Redirecionando para ' + acessoExterno.urlDestino);
            this.generateCookiesUri(acessoExterno.chaveAcesso);

            new RegistrarTipoAutenticacaoAction(TipoAutenticacaoEnum.GovBR).dispatch().then((state) => {
              this.consultarTramiteExterno(acessoExterno);
            });
            this.svc.sessionStorageService.removeTokenAcessoExterno();
            this.loadingService.liberaTela();
            return;
        })
        .catch((error: any) =>
        {
            if (error instanceof HttpErrorResponse)
            {
              this.svc.bnAlertService.alertaErro(`Erro ${error.status}`, error.message);
              return;
            }
            if (error instanceof ErroApp)
            {
                if (this.svc.errorHandlerService.ehNivelInvalidoGovBR(error))
                {
                  this.router.navigate(['acesso-gov-br-bronze']);
                  return;
                }
                if (this.svc.errorHandlerService.ehSessaoGovBrExpirada(error))
                {
                  this.svc.acessoExternoService.realizarLogoutGovBr('sessaoExpirada');
                  this.contarErro++;
                  return;
                }
                this.svc.bnAlertService.alertaErro('Erro', error.cabecalho + ' Não foi possível realizar o acesso utilizando GOV.BR', error.listaComentarios);
                this.contarErro++;
                this.svc.acessoExternoService.realizarLogoutGovBr('sessaoExpirada');
                return;
            }
            this.svc.bnAlertService.alertaErro('Erro', 'Não foi possível realizar o acesso utilizando GOV.BR');
            this.svc.acessoExternoService.realizarLogoutGovBr('sessaoExpirada');
        });
    }


    private getChaveUsuario(acessoExterno: any) {
      return acessoExterno.idAssinante && !isNaN(acessoExterno.idAssinante) ? acessoExterno.idAssinante : acessoExterno.idDestinatario;
    }

    private navegarParaVisualizacaoTramite(state: any, acessoExterno: any)
    {
      if (state.documentoTramite.tipoSituacaoTramite == TipoSituacaoTramiteEnum['Rejeitado']) {
          this.svc.bnAlertService.alertaErro('Erro', 'O documento do tramite esta rejeitado.');
          return;
      }

      let chaveUsuario = this.getChaveUsuario(acessoExterno);
      this.router.navigate(['visualizador', chaveUsuario, acessoExterno.chaveAcesso]);
      return;
    }
    private consultarTramiteExterno(acessoExterno: AcessoExterno) {
        new ConsultarTramiteExternoAction(acessoExterno.chaveAcesso, parseInt(this.getChaveUsuario(acessoExterno))).dispatch().then((state) => {
            this.navegarParaVisualizacaoTramite(state, acessoExterno);
        });
    }

    onChangeWhitespaceRemover(){
        this.removerWhiteSpace('codigoAcesso');
        this.removerWhiteSpace('email');

      }
    private removerWhiteSpace(nomeCampo: string)
    {
      this.formulario.formGroup.get(nomeCampo).setValue(this.formulario.formGroup.get(nomeCampo).value.replace(/\s/g, ""));
    }

    private cookiesConsent() {
        if (this.cookieService.get("cpc") && this.cookieService.get("cpc").match("1")) {
            this.acessoExterno.cookiesConsent = true;
            this.formulario.formGroup.enable();
        } else {
            this.formulario.formGroup.disable();
            this.acessoExterno.cookiesConsent = false;
        }
    }

    private generateCookiesUri(chaveAcesso: string) {
        this.cookieService.delete('uri');
        this.cookieService.set('uri', chaveAcesso, 10, "", "", true,'Strict');
    }

    protected alertarErro(titulo: string, cabecalho: string, err: any) {
        if (err instanceof HttpErrorResponse) {
          this.svc.bnAlertService.alertaErro(`Erro`, err.message);
          return;
        }
        if (err instanceof ErroApp) {
            this.svc.bnAlertService.alertaErro(titulo, err.cabecalho + ' ' + cabecalho, err.listaComentarios);
            return;
        }
        if (err == null) {
            this.svc.bnAlertService.alertaErro(titulo, cabecalho);
            return;
        }
        this.svc.bnAlertService.alertaErro(titulo,  cabecalho, err);
    }

    handleCorrectCaptcha(event: any) {
        this.loginCaptchaResposta = event;
    }

}
